import { defineComponent as _defineComponent } from 'vue'
import XIcon from '@/components/svg/questionmark-circle.svg?inline';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';
import { ref } from 'vue';
import useMessengerState from '@/state/messenger/messengerState';
import { whenever } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXSidebarHelpContainer',
  props: {
  helpText: {
    type: String,
    default: ''
  },
  hangDown: {
    type: Number,
    default: 0
  },
  iconPos: {
    type: String,
    default: '7px'
  }
},
  setup(__props) {



const { isOpened: isMessengerOpened } = useMessengerState();

const isOpen = ref(false);

whenever(isOpen, () => {
  isMessengerOpened.value = false;
});

return { __sfc: true,isMessengerOpened, isOpen, XIcon, BCXInfoCollapsible }
}

})